import { useEffect } from 'react';

function parseQueryString(qs) {
  const params = {};
  qs.replace(/^\?/, '').split('&').forEach(pair => {
    const [key, value] = pair.split('=');
    if (key) params[decodeURIComponent(key)] = decodeURIComponent(value || '');
  });
  return params;
}

const SetUtypeFromQuery = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      try {
        const decoded = atob(token);
        const parsed = parseQueryString(decoded);
        if (parsed.utype && localStorage.getItem('utype') !== parsed.utype) {
          localStorage.setItem('utype', parsed.utype);
        }
      } catch (e) {
        // ignore
      }
    } else {
      const utype = params.get('utype');
      if (utype && localStorage.getItem('utype') !== utype) {
        localStorage.setItem('utype', utype);
      }
    }
  }, []);
  return null;
};

export default SetUtypeFromQuery; 